import { motion } from "motion/react";
import { DISHA_CONTACT } from "../../lib/constants";

interface DishaContactBannerProps {
  show: boolean;
}

export function DishaContactBanner({ show }: DishaContactBannerProps) {
  if (!show) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{
        duration: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      className="mb-4 mx-4"
    >
      <div className="bg-linear-to-br border border-sky-200/60 from-sky-50 overflow-hidden p-5 relative rounded-2xl shadow-lg shadow-sky-900/10 to-indigo-50 via-blue-50">
        {/* Subtle pattern overlay */}
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgba(56, 189, 248, 0.15) 1px, transparent 0)`,
            backgroundSize: "24px 24px",
          }}
        />

        <div className="relative">
          <div className="flex gap-3 items-center mb-3">
            <motion.div
              animate={{
                scale: [1, 1.15, 1],
              }}
              transition={{
                duration: 2,
                repeat: Number.POSITIVE_INFINITY,
                ease: "easeInOut",
              }}
              className="text-2xl"
            >
              💙
            </motion.div>
            <h3 className="font-semibold text-lg text-sky-900">
              The Disha Team is here for you
            </h3>
          </div>

          <p className="leading-relaxed mb-4 text-sky-800/80 text-sm">
            {DISHA_CONTACT.message}
          </p>

          <div className="flex flex-col gap-3 sm:flex-row">
            <a
              href={`mailto:${DISHA_CONTACT.email}`}
              className="bg-white/70 border border-sky-200/50 duration-200 flex font-medium gap-2 hover:bg-white hover:border-sky-300 hover:shadow-md items-center px-4 py-2.5 rounded-xl shadow-sm text-sky-800 text-sm transition-all"
            >
              <span className="text-lg">📧</span>
              {DISHA_CONTACT.email}
            </a>

            <a
              href={`tel:${DISHA_CONTACT.phone.replace(/[^+\d]/g, "")}`}
              className="bg-white/70 border border-sky-200/50 duration-200 flex font-medium gap-2 hover:bg-white hover:border-sky-300 hover:shadow-md items-center px-4 py-2.5 rounded-xl shadow-sm text-sky-800 text-sm transition-all"
            >
              <span className="text-lg">📞</span>
              {DISHA_CONTACT.phone}
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
